import { render } from "./Activity.vue?vue&type=template&id=b7a1bfae&scoped=true"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"

import "./Activity.vue?vue&type=style&index=0&id=b7a1bfae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a1bfae"]])

export default __exports__